/*
 * 全局环境配置
 * @api  后台api地址
 * @link 全局链接地址
 */
const CONFIG = {
  // baseURL: 'http://answer-game-test.co-study.com.cn/',
  // baseURL: 'http://web-answer-game-test.co-life.cn/',    // 测试环境
  baseURL: 'http://www.co-study.com.cn/',   // 生产
  // baseURL: 'http://web-answer-game.co-life.cn/',     // 生产环境
  // baseURL: 'http://192.168.1.101:5000/',
  // baseURL: 'http://192.168.1.100:8002/',
  // baseURL: 'http://192.168.1.101:8002/',
  // baseURL: 'http://test.co-study.com.cn/',
  // baseURL: 'http://app.co-study.com.cn/',

  coApi: 'https://slb.co-study.com.cn/',     // 生产环境
  // coApi: 'http://192.168.1.101:5000/',
  // coApi: 'http://test.co-study.com.cn/',   // 测试环境
  // coApi: 'http://192.168.1.101:5000/'
  // coApi: 'http://106.15.227.20:3333/', 

  wechatAppid: 'wx907373b61d25eab2',    // 生产环境
  // wechatAppid: 'wxf4ecef8bfb4e436b',    // 测试环境

  qqAppid: '101905808',  // 生产
  // qqAppid: '101912676',   //  测试
}

export default CONFIG